import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllFinancialYears, getProjectFinancialStatusSummaryReportGrid } from '../../api/ReportsAPI/projectFinancialStatusSummaryAPI';

const err = (e, fallback) => e?.Message || e?.message || fallback;

export const fetchPFSSFinancialYears = createAsyncThunk('projectFinancialStatusSummary/fetchYears', async (_, { rejectWithValue }) => {
    try { const res = await getAllFinancialYears(); return res?.Data || []; }
    catch (e) { return rejectWithValue(err(e, 'Failed to fetch financial years')); }
});

export const fetchProjectFinancialStatusSummary = createAsyncThunk('projectFinancialStatusSummary/fetchReport', async (params, { rejectWithValue }) => {
    try { const res = await getProjectFinancialStatusSummaryReportGrid(params); return res?.Data || null; }
    catch (e) { return rejectWithValue(err(e, 'Failed to fetch project financial status summary')); }
});

const initialState = {
    years: [], yearsLoading: false,
    report: null, reportLoading: false, reportError: null,
};

const projectFinancialStatusSummarySlice = createSlice({
    name: 'projectFinancialStatusSummary',
    initialState,
    reducers: {
        clearPFSSReport: (s) => { s.report = null; s.reportError = null; },
        resetPFSSReport: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPFSSFinancialYears.pending, (s) => { s.yearsLoading = true; })
            .addCase(fetchPFSSFinancialYears.fulfilled, (s, a) => { s.yearsLoading = false; s.years = a.payload; })
            .addCase(fetchPFSSFinancialYears.rejected, (s) => { s.yearsLoading = false; });

        builder
            .addCase(fetchProjectFinancialStatusSummary.pending, (s) => { s.reportLoading = true; s.reportError = null; })
            .addCase(fetchProjectFinancialStatusSummary.fulfilled, (s, a) => { s.reportLoading = false; s.report = a.payload; })
            .addCase(fetchProjectFinancialStatusSummary.rejected, (s, a) => { s.reportLoading = false; s.reportError = a.payload; });
    },
});

export const { clearPFSSReport, resetPFSSReport } = projectFinancialStatusSummarySlice.actions;

export const selectPFSSYears         = (s) => s.projectFinancialStatusSummary.years;
export const selectPFSSYearsLoading  = (s) => s.projectFinancialStatusSummary.yearsLoading;
export const selectPFSSReport        = (s) => s.projectFinancialStatusSummary.report;
export const selectPFSSReportLoading = (s) => s.projectFinancialStatusSummary.reportLoading;
export const selectPFSSReportError   = (s) => s.projectFinancialStatusSummary.reportError;

export default projectFinancialStatusSummarySlice.reducer;
